import { Injectable } from '@angular/core';
import { HttpRequestUtils } from './util/http-request-utils';

/**
 * Encapsulates generic configuration, such as the dev mode, etc.
 * @author jsanca
 */

export class Config {
    private httpRequestUtils: HttpRequestUtils;

    constructor() {
        this.httpRequestUtils = new HttpRequestUtils();
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
} // E:O:F:Config

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
